__turbopack_context__.v({
  "link": "link-module-scss-module__tY_VHW__link",
  "textPrimary": "link-module-scss-module__tY_VHW__textPrimary",
});
